import React from 'react';

import type { JiraAdminAgentFieldStepPayload } from '@atlassian/ai-mate-jira-admin-agent-api/jira-admin-agent';

import type { StepNode } from '../../types';

import { FieldOptionsBody } from './field-options/FieldOptionsBody';
import { FieldBody } from './field/FieldBody';

export type IntentBodyProps = {
	steps: StepNode[];
};

/**
 * Renders the body of an intent (or step) from its `actionSubject` + `payload`.
 * Shared between the inline action cards and the review canvas. As new action
 * subjects land, add a `case` here that delegates to that subject's body.
 */
export const IntentBody = ({ steps }: IntentBodyProps): React.JSX.Element | null => {
	if (steps.length === 0) {
		return null;
	}

	switch (steps[0].actionSubject) {
		case 'field-options':
			return <FieldOptionsBody steps={steps} />;
		case 'field':
			return <FieldBody payload={steps[0].payload as JiraAdminAgentFieldStepPayload['payload']} />;
		default:
			return null;
	}
};
